import hgpSelect from './pages/main';

export default {
  install(Vue) {
    Vue.component(hgpSelect.name, hgpSelect);
  },
};
